import React from "react";
import { Form } from "semantic-ui-react";
import { Editor } from "@tinymce/tinymce-react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { supportAPI } from "../../../api";
import { initialValues, validationSchema } from "./SupportForm.form";
import "./SupportForm.scss";
import { ENV } from "../../../Utils/constants";

const supportController = new supportAPI();

export function SupportForm(props) {
  const { onClose, onReload, ticket, accessToken, user } = props;
  const { t } = useTranslation("misc");

  // Si no tenemos ticket, es creación
  const isCreation = !ticket;
  const mainButtonText = isCreation
    ? t("support.form.submitCreate")
    : t("support.form.submitReply");

  const formik = useFormik({
    initialValues: initialValues(ticket),
    validationSchema: validationSchema(isCreation),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (isCreation) {
          // CREAR TICKET
          const dataToSend = {
            title: formValue.title,
            description: formValue.description,
            message: formValue.message,
            clientInputId: user.user._id, // Ajusta la ruta si es user.user._id
            clientOutputId: user.user.partner, // Partner ID
            senderRole: user.user.role,
          };
          await supportController.createTicket(accessToken, dataToSend);
        } else {
          // RESPONDER TICKET
          const dataToSend = {
            userId: user.user._id, // Ajusta si es user.user._id
            senderRole: user.user.role,
            message: formValue.message,
          };
          await supportController.respondTicket(
            accessToken,
            ticket._id,
            dataToSend,
          );
        }

        onReload();
        onClose();
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <Form className="support-form" onSubmit={formik.handleSubmit}>
      {/* Campos solo visibles en creación */}
      {isCreation && (
        <>
          <Form.Field>
            <label>{t("support.form.titleLabel")}</label>
            <Form.Input
              name="title"
              placeholder={t("support.form.titlePlaceholder")}
              onChange={formik.handleChange}
              value={formik.values.title}
              error={formik.errors.title}
            />
          </Form.Field>

          <Form.Field>
            <label>{t("support.form.descriptionLabel")}</label>
            <Form.Input
              name="description"
              placeholder={t("support.form.descriptionPlaceholder")}
              onChange={formik.handleChange}
              value={formik.values.description}
              error={formik.errors.description}
            />
          </Form.Field>
        </>
      )}

      <Form.Field>
        <label>
          {isCreation
            ? t("support.form.firstMessageLabel")
            : t("support.form.replyLabel")}
        </label>
        <Editor
          apiKey={ENV.TINY_APIKEY}
          init={{
            height: 300,
            menubar: true,
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount",
            ],
            toolbar:
              "undo redo | formatselect | bold italic backcolor | " +
              "alignleft aligncenter alignright alignjustify | " +
              "bullist numlist outdent indent | removeformat | help",
          }}
          initialValue={formik.values.message}
          onBlur={(e) => formik.setFieldValue("message", e.target.getContent())}
        />
      </Form.Field>

      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {mainButtonText}
      </Form.Button>
    </Form>
  );
}
